export default "__VITE_ASSET__DeaDTfem__"